import { SetStateOptions } from '../interfaces/state.interface';
import { setMemo } from './set-memo';

/**
 *
 * @param key
 * @param value
 * @param options
 */
export function setState(key: string, value: any, options: SetStateOptions = { save: true }) {
    return setMemo(key, value, options);
}
